import React, { useRef } from "react";
import { Footer } from "./Footer";
import Brands from "./Brands";
import { FaFacebookF } from 'react-icons/fa';
import emailjs from "emailjs-com";
import { useTranslation } from "react-i18next";
import { Col, Container, Row, Button } from "react-bootstrap";
import aimg from "../Assets/img/brabout.jpg";
import GoTop from "./GoTop";
import brc from "../Assets/img/qandelbrc.png";
import bgImage from "../Assets/img/bgs/17.jpeg";
import Navigation from "./Navigation";

const QandelBrc = ({ lang: currentLanguage }) => {
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_inyaa89",
        "template_993qouc",
        form.current,
        "user_DfrMcD1i8Klde4wR1m0qR"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    form.current.reset();

  };
    const { t } = useTranslation();

 
  const aboutTextClass = () => {
    switch (currentLanguage.code) {
      case 'en':
        return 'about-text-en';
      case 'ar':
        return 'about-text-ar';
      case 'kur':
        return 'about-text-kur';
      default:
        return ''; // Fallback class
    }
  };
  
  const menu = ["about", "qandelBrc"];
  return (
    <>
      <Navigation navs={menu} />
      <div id="qb-head" >
       {/* Ensure the class is b-bg-container, NOT b-bg */}
     <div className="hero-motion-container">
  {/* Layer 1: Background */}
  <img src={bgImage} className="hero-motion-bg" alt="" />
  
  {/* Layer 2: Content on top */}
  <div className="hero-motion-overlay">
    <img src={brc} className="hero-motion-logo" alt="Logo" />
    <h3 style={{ color: '#000', fontWeight: '700' }}>{t("br_top_header1")}</h3>
        </div>
      </div>
      </div>
      {/* Brands */}
      <Brands />
       {/* ABOUT */}
                  <div id="about" className="s-about" data-aos="fade-up" data-aos-duration="1000">
              <div className="s-about-inner">
                      <Container>
                        <Row>
                          <Col
                              md={6}
                              className="left d-flex justify-content-center align-items-cenetr"
                             >
                             <div className="text-center">
                            <img src={aimg} className="about-img-brc1 img-fluid" alt={t("p_type1")} />
                             </div>
                          </Col>
                          <Col xs={12} md={6} className="about-us">
                                          <div className={`about-text ${aboutTextClass()}`}>
                                            <h2 className={` ${currentLanguage.dir === "ltr" ? "h2Font" : "h2rtl"}`}>
                                              {t("about_us")}
                                            </h2>
                                            <div className="mb-4">
                                              <hr className="hr" />
                                            </div>
                                            <div className={`about-text ${aboutTextClass()}`}>
                                              <p>{t("brabout_p")}</p>
                                            </div>
                                          </div>
                                        </Col>
                        </Row>
                     </Container>
                    </div>
                  </div>
                  {/* the article */}
                  <div className="article-text-box" data-aos="fade-up" data-aos-duration="1000">
                          <Container>
                            <div className="article">
                             {/* What is BRC */}
                                        <div className="whatssandwich mb-5" data-aos="fade-in" data-aos-duration="1500">
                                          <Container>
                                            <h4
                                              className={`mb-1  ${currentLanguage.dir === "ltr" ? "h2Font" : "h3rtl"}`}
                                            >
                                              {t("brdesc")}
                                            </h4>
                                            <div className="mb-3">
                                              <hr className="s-hr" />
                                            </div>
                                            <div className="app-text">
                                              <p className="w-75">{t("brdesc_p")}</p>
                                            </div>
                                          </Container>
                                        </div>
                              
                              
                             {/* Key Advantages */}
                                         <div className="s-types mb-5" data-aos="fade-in" data-aos-duration="1500">
                                           <Container>
                                             <Row>
                                               <h4
                                                 className={`mb-1 ${
                                                   currentLanguage.dir === "ltr" ? "h2Font" : "h3rtl"
                                                 }`}
                                               >
                                                 {t("brad")}
                                               </h4>
                                               <div className="mb-3 ">
                                                 <hr className="s-hr" />
                                               </div>
                                               <Col sm={12} className="px-md-5">
                                                 <ul className="p-0 m-0 mb-4 list-types ">
                                                   <li>{t("brad1")}</li>
                                                   <li>{t("brad2")}</li>
                                                   <li>{t("brad3")}</li>
                                                   <li>{t("brad4")}</li>
                                                 </ul>
                                               </Col>
                                             </Row>
                                           </Container>
                                         </div>
                                          {/* Technical Spesifications */}
                                          <div className="s-available mb-5" data-aos="fade-in" data-aos-duration="1500">
                                                <Container>
                                                         <h4
                                                           className={`mb-1 ${currentLanguage.dir === "ltr" ? "h2Font" : "h3rtl"}`}
                                                         >
                                                           {t("brspe")}
                                                         </h4>
                                                         <div className="mb-3">
                                                           <hr className="s-hr" />
                                                         </div>
                                                        <div className="app-text">
                                                         <p className="w-75">{t("brspep")}</p>
                                                        </div>
                                                         <Row>
                                                           <table className="table table-sm text-center w-75">
                                                             <thead>
                                                               <tr className="table-primary">
                                                                 <th scope="col">{t("feature")}</th>
                                                                 <th scope="col">{t("specification")}</th>
                                                               </tr>
                                                             </thead>
                                                             <tbody>
                                                               <tr>
                                                                 <td>{t("ad")}</td>
                                                                 <td>{t("ad1")}</td>
                                                               </tr>
                                                               <tr>
                                                                 <td>{t("od")}</td>
                                                                 <td>{t("od1")}</td>
                                                               </tr>
                                                               <tr>
                                                                 <td>{t("sd")}</td>
                                                                 <td>{t("sd1")}</td>
                                                               </tr>
                                                               <tr>
                                                                 <td>{t("ms")}</td>
                                                                 <td>{t("ms1")}</td>
                                                               </tr>
                                                             </tbody>
                                                           </table>
                                                         </Row>
                                                         <div className="app-text">
                                                         <p className="w-75">{t("note_p")}</p>
                                                        </div>
                                                  </Container>
                                            </div>
                                            {/* Feild of Application */}
                                                        <div className="specifications1 mb-5" data-aos="fade-in" data-aos-duration="1500">
                                                          <div className="overlay">
                                                            <Container>
                                                              <Row>
                                                                <h4
                                                                  className={`mb-1 ${
                                                                    currentLanguage.dir === "ltr" ? "h2Font" : "h3rtl"
                                                                  }`}
                                                                >
                                                                  {t("feilofap")}
                                                                </h4>
                                                                <div className="mb-3 ">
                                                                  <hr className="s-hr" />
                                                                </div>
                                                                <Col sm={12} md={7} className="px-md-4 px-lg-5">
                                                                  <ul className="p-0 m-0 ">
                                                                    <li>{t("foa1")}</li>
                                                                    <li>{t("foa2")}</li>
                                                                    <li>{t("foa3")}</li>
                                                                    <li>{t("foa4")}</li>
                                                                    <li>{t("foa5")}</li>
                                                                  </ul>
                                                                </Col>
                                                              </Row>
                                                            </Container>
                                                          </div>
                                                          </div>
                                                          {/* Why Choose Al-Qandel BRC */}
                                         <div className="s-types mb-5" data-aos="fade-in" data-aos-duration="1500">
                                           <Container>
                                             <Row>
                                               <h4
                                                 className={`mb-1 ${
                                                   currentLanguage.dir === "ltr" ? "h2Font" : "h3rtl"
                                                 }`}
                                               >
                                                 {t("brwhy")}
                                               </h4>
                                               <div className="mb-3 ">
                                                 <hr className="s-hr" />
                                               </div>
                                               <Col sm={12} className="px-md-5">
                                                 <ul className="p-0 m-0 mb-4 list-types ">
                                                   <li>{t("brwhy1")}</li>
                                                   <li>{t("brwhy2")}</li>
                                                   <li>{t("brwhy3")}</li>
                                                   <li>{t("brwhy4")}</li>
                                                   <li>{t("brwhy5")}</li>
                                                   <li>{t("brwhy6")}</li>
                                                 </ul>
                                               </Col>
                                             </Row>
                                           </Container>
                                         </div>
                                         {/* Quality and Standards */}
                                        <div className="whatssandwich mb-5" data-aos="fade-in" data-aos-duration="1500">
                                          <Container>
                                            <h4
                                              className={`mb-1  ${currentLanguage.dir === "ltr" ? "h2Font" : "h3rtl"}`}
                                            >
                                              {t("quality")}
                                            </h4>
                                            <div className="mb-3">
                                              <hr className="s-hr" />
                                            </div>
                                            <div className="app-text">
                                              <p className="w-75">{t("quality_p")}</p>
                                            </div>
                                          </Container>
                                        </div>

        </div>
        </Container>
        </div>

 {/* CONTACT */}
      <div id="contact">
        <div className="overlay">
          <Container>
            <Row>
              <Col lg={{ span: 6, order: 2 }} className=" contactFormCol">
                <div className="contact-us">
                  <h4
                    className={`mb-4 text-center ${
                      currentLanguage.dir === "ltr" ? "h2Font" : "h3rtl"
                    }`}
                  >
                    {t("contact_form")}
                  </h4>
                  <form ref={form} onSubmit={sendEmail}>
                    <div className="form-group">
                      <label htmlFor="name">{t("name")} :</label>
                      <input
                        type="text"
                        className="form-control form-control-sm my-1"
                        id="name"
                        placeholder={t("name")}
                        name="name"
                        required
                      />
                    </div>
                    <div className="form-group my-3">
                      <label htmlFor="email">{t("email")} :</label>
                      <input
                        type="email"
                        className="form-control form-control-sm my-1"
                        id="email"
                        placeholder={t("email")}
                        aria-describedby="emailHelp"
                        name="email"
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="message">{t("message")} :</label>
                      <textarea
                        className="form-control form-control-sm my-1"
                        id="message"
                        placeholder={t("message")}
                        rows="3"
                        name="message"
                        required
                      ></textarea>
                    </div>
                    <div className="d-flex flex-row">
                      <Button
                        variant="primary"
                        className="mt-3 px-3 btn-sm"
                        type="submit"
                      >
                        {t("send_message")}
                      </Button>
                    </div>
                  </form>
                </div>
              </Col>
              <Col lg={{ span: 6, order: 1 }} className="text-center px-4 py-4">
                <h3
                  className={`mb-4 ${
                    currentLanguage.dir === "ltr" ? "h2Font" : "h2rtl"
                  }`}
                >
                  {t("br_app_title")}
                </h3>
                <p className="fs-7 mb-5">
                  Al Qandel Factory is one of the newest industrial facilities in Fallujah, specializing in the production of electrically welded reinforcement mesh (BRC). 
                </p>
                <h6>{t("address")}</h6>
                <p className="px-5">{t("br_add_value")}</p>
                <h6>{t("phone")}</h6>
                <a href="tel:+9647724321332" className="contactLinks">
                  +964_772_432_1332
                </a>{" "}
                <br />
                <a href="tel:+9647802271010" className="contactLinks">
                  +964_780_227_1010
                </a>
                <h6>{t("email")}</h6>
                <a href="mailto:qandelbrc@gmail.com" className="contactLinks">
                  qandelbrc@gmail.com
                </a>
                <br />
                                                  {/* Wrap this in a div to center it properly */}
                                  <div className="mt-3 d-flex justify-content-center">
                                    <a 
                                      href="https://www.facebook.com/AlQandelBRC/" 
                                      target="_blank" 
                                      rel="noopener noreferrer" 
                                      className="facebook-link-crisp"
                                    >
                                      <div className="fb-icon-circle">
                                        <FaFacebookF className="fb-vector-icon" />
                                      </div>
                                      <span className="fb-text">AL-Qandel BRC Factory</span>
                                    </a>
                                  </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
      <div>
        <iframe
          title="runaky-location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3333.0700761756957!2d43.794772!3d33.343119!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1559f7006a4c3e9f%3A0x99629d061abe5fb2!2zUWFuZGVsIEJSQ9iMINmF2LnZhdmEINmC2YbYr9mK2YQ!5e0!3m2!1sen!2siq!4v1776955870871!5m2!1sen!2siq" 
          width="100%"
          height="100% "
          allowFullScreen
          loading="lazy"
        ></iframe>
      </div>
      <Footer />
      <GoTop id="qb-head" />
    </>
    
    
  );
};

export default QandelBrc;